<template>
	<section class="section-card">
		<div class="section-head">
			<h2 class="section-title">四、最终结论</h2>
		</div>
		<p class="section-desc">对上方证据做收口，只给结论归纳和下一步建议。</p>

		<div class="conclusion-body">
			<div class="conclusion-card conclusion-card--summary">
				<div class="conclusion-card__header">
					<i class="el-icon-document-checked"></i>
					<span>结论归纳</span>
				</div>
				<div class="conclusion-card__content">
					<p class="conclusion-summary">{{ conclusion.summary }}</p>
					<div class="finding-list">
						<div class="finding-item" v-for="(item, index) in conclusion.keyFindings" :key="index">
							<span class="finding-dot"></span>
							<span class="finding-text">
								{{ item.label }}：{{ item.value }}，
								<strong :class="item.status === '偏高' ? 'up' : 'down'">{{ item.status }}</strong>
								， 偏离 {{ item.deviation }}
							</span>
						</div>
					</div>
				</div>
			</div>

			<div class="conclusion-card conclusion-card--recommendation">
				<div class="conclusion-card__header">
					<i class="el-icon-s-opportunity"></i>
					<span>处理建议</span>
				</div>
				<div class="conclusion-card__content">
					<div class="recommendation-list">
						<div v-if="!recommendations.length" class="recommendation-empty">暂无处理建议。</div>
						<div class="recommendation-item" v-for="(item, index) in recommendations" :key="index">
							<span class="recommendation-index">{{ index + 1 }}</span>
							<span class="recommendation-text">{{ item }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'ConclusionSection',
	props: {
		profileData: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		conclusion() {
			return (this.profileData && this.profileData.conclusion) || {}
		},
		recommendations() {
			return this.conclusion.recommendations || []
		},
	},
}
</script>

<style lang="scss" scoped>
.section-card {
	position: relative;
	padding: 22px 24px 18px;
	background: var(--panel-bg);
	border: 1px solid var(--panel-border);
	border-radius: 12px;
	box-shadow: var(--panel-shadow);
	backdrop-filter: blur(12px);
}

.section-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 8px;
}

.section-title {
	margin: 0;
	color: var(--title);
	font-size: 17px;
	font-weight: 700;
	letter-spacing: 0.01em;
}

.section-desc {
	margin: 0 0 16px;
	font-size: 13px;
	color: var(--muted);
	line-height: 1.6;
}

.conclusion-body {
	display: flex;
	gap: 16px;
	align-items: flex-start;
}

.conclusion-card {
	flex: 1;
	min-width: 0;
	border-radius: 10px;
	padding: 18px;

	&--summary {
		background: #fff7ed;
		border: 1px solid #fed7aa;
	}

	&--recommendation {
		background: #eff6ff;
		border: 1px solid #bfdbfe;
	}
}

.conclusion-card__header {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 15px;
	font-weight: 700;
	color: var(--title);
	margin-bottom: 14px;
	padding-bottom: 10px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);

	i {
		font-size: 18px;
	}

	.conclusion-card--summary & {
		color: #9a3412;
		i {
			color: #f97316;
		}
	}

	.conclusion-card--recommendation & {
		color: #1e40af;
		i {
			color: #2563eb;
		}
	}
}

.conclusion-card__content {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.conclusion-summary {
	margin: 0;
	font-size: 14px;
	line-height: 1.7;
	color: var(--text);
}

.finding-list {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.finding-item {
	display: flex;
	align-items: flex-start;
	gap: 8px;
	font-size: 13px;
	color: var(--text);
	line-height: 1.6;
}

.finding-dot {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: #f97316;
	flex-shrink: 0;
	margin-top: 7px;
}

.finding-text {
	flex: 1;

	strong {
		&.up {
			color: #dc2626;
		}
		&.down {
			color: #2563eb;
		}
	}
}

.recommendation-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.recommendation-empty {
	font-size: 13px;
	line-height: 1.7;
	color: var(--muted);
	margin-bottom: 11px;
}

.recommendation-item {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	font-size: 13px;
	color: var(--text);
	line-height: 1.7;
}

.recommendation-index {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background: #2563eb;
	color: #fff;
	font-size: 11px;
	font-weight: 700;
	flex-shrink: 0;
	margin-top: 1px;
}

.recommendation-text {
	flex: 1;
}

@media (max-width: 1240px) {
	.conclusion-body {
		flex-direction: column;
	}
}
</style>
